
export type GetPollResults200OptionsItemAllOfTwo = {
  /** 전체 투표 중 해당 옵션의 비율 (0-100) */
  percentage?: number;
};
